import React, { useState } from "react";
import { GetAccess, GetRole } from "../../../utils/RolesandAccess";
import { ViewMoreIcon } from "../../../assets/icons";
import useDeleteData from "../../../hooks/useDeleteData";
import CreateorUpdate from "./form";
import ViewEmailTemplate from "./viewEmailTemplate";

function ViewMore({ fetcher, data}) {
  const { handleDelete } = useDeleteData();
  const [showMyModal, setShowMyModal] = useState(false);
  const handleOnClose = () => setShowMyModal(false);
  const [showFile, setShowFile] = useState(false);
  const handleClose = () => setShowFile(false)
  return (
    <>
      <div className="hover:drop-shadow-sm mr-2 py-2 px-[14px] rounded-3xl dropdown bg-white cursor-pointer relative">
        <ViewMoreIcon />
        <div className="hidden dropdown-menu">
          <div
            id="modal"
            className="bg-transparent fixed inset-0 flex justify-center items-center "
          ></div>
          <div className="bg-white text-left rounded-xl w-20 absolute -left-20 -top-1">
            <div className="grid p-1 rounded-t">
            <span className="p-1 hover:bg-navhover hover:rounded-lg" onClick={() => setShowFile(true)}>View</span>
              {GetAccess("admin_edit") && (
                <span
                  className="p-1 hover:bg-navhover hover:rounded-lg cursor-pointer"
                  onClick={() => setShowMyModal(true)}
                >
                  Edit
                </span>
              )}
              {GetRole() && (
                <span
                  className="p-1 hover:bg-navhover hover:rounded-lg"
                  onClick={() => {
                    handleDelete({
                      url: `/email_templates/${data?.id}`,
                      value:data?.status_name,
                      fetcher: fetcher,
                    });
                  }}
                >
                  Delete
                </span>
              )}
            </div>
          </div>
        </div>
      </div>
      <CreateorUpdate
        onClose={handleOnClose}
        visible={showMyModal}
        data={data}
        refreshData={fetcher}
      />
      <ViewEmailTemplate data={data} onClose={handleClose} visible={showFile}/>

    </>
  );
}

export default ViewMore;
